import React from 'react';
import DocumentoLegalPage from '../DocumentoLegalPage/DocumentoLegalPage';

export default function TermosPage() {
  return (
    <DocumentoLegalPage
      tipo="termos"
      tituloPagina="Termos de Uso"
      voltarPara="/cadastro"
    />
  );
}
